export function getCookie(name: string): string | null {
    const cookieArr = document.cookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split('=');

        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }

    return null;
}

export function setCookie(
    name: string,
    value: string,
    expires: string,
    path = '/',
    secure = false,
    sameSite: 'Lax' | 'Strict' | 'None' = 'Lax'
): void {
    let cookie = `${name}=${value}; expires=${expires}; path=${path}; SameSite=${sameSite}`;

    if (secure) {
        cookie += '; Secure';
    }

    document.cookie = cookie;
}
